import "./LocationTestAndPanelsAddComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import commonService from "../../../../shared/services/common.service";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../../shared/components/tabs/tabsComponent";
import CheckBoxComponent from "../../../../shared/components/core/checkbox/CheckboxComponent";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import DrawerComponent from "../../../../shared/components/drawer/drawerComponent";
import {CommonService} from "../../../../shared/services";
import {useSearchParams} from "react-router-dom";
import LoaderComponent from "../../../../shared/components/loader/loaderComponent";
import TestDetailsComponent from "../../../../shared/components/test-details/TestDetailsComponent";

interface LocationTestAndPanelsAddComponentProps {
    locationId: any;
    cancel: Function;
    next: Function;
    prev: Function;
    selectedTestsAndPanels: any;
    locationDetails: any;
}

const TESTS = 'tests';
const TEST_PANELS = 'test_panels';
const LocationTestAndPanelsAddComponent = (props: LocationTestAndPanelsAddComponentProps) => {
    const {locationId, cancel, next, prev, selectedTestsAndPanels, locationDetails} = props;
    const [isEdited, setIsEdited] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState<typeof TESTS|typeof TEST_PANELS>(TESTS);
    const {biomarkerList} = useSelector((state: any) => state.staticData);
    const [viewDetailsDrawerOpen, setViewDetailsDrawerOpen] = React.useState(false);
    const [testOrPanelDetails, setTestOrPanelDetails] = React.useState<any>(undefined); // [testOrPanelDetails, setTestOrPanelDetails
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [selectedTestAndTestPanelIds, setSelectedTestAndTestPanelIds] = React.useState<any>({
        testIds: [],
        panelIds: []
    });
    const [searchParams] = useSearchParams();
    const lastCompletedStep = searchParams.get("lastCompletedStep");

    const [labTest, setLabTest] = useState<any>(undefined);
    const [labPanel, setLabPanel] = useState<any>(undefined);
    const [isLocationTestAndPanelLoading, setIsLocationTestAndPanelLoading] = useState(false);
    const [isLocationTestAndPanelLoaded, setIsLocationTestAndPanelLoaded] = useState(false);

    const handleGetLabTestAndPanel = useCallback((labID: string) => {
        const payload = {}
        setIsLocationTestAndPanelLoading(true);
        setIsLocationTestAndPanelLoaded(false);
        CommonService._lab.getLabTestAndPanels(labID, payload)
            .then((res: any) => {
                setIsLocationTestAndPanelLoading(false);
                setIsLocationTestAndPanelLoaded(true);
                setLabPanel(res?.data?.panelDetails);
                setLabTest(res?.data?.testDetails);
            })
            .catch((err: any) => {
                setIsLocationTestAndPanelLoading(false);
                setIsLocationTestAndPanelLoaded(false);
                setLabPanel(undefined);
                setLabTest(undefined);
            })
    }, []);

    useEffect(() => {
        handleGetLabTestAndPanel(locationDetails?.labId);
    }, [locationDetails, handleGetLabTestAndPanel]);


    const handleGetLocationTestAndPanel = useCallback((locationId: string) => {
        const payload = {}
        CommonService._location.getLocationTestAndPanels(locationId, payload)
            .then((res: any) => {
                const locationTestAndPanel = res?.data;
                if (locationTestAndPanel?.panelDetails?.length > 0 || locationTestAndPanel?.testDetails?.length > 0) {
                    setIsEdited(true);
                    setSelectedTestAndTestPanelIds(() => {
                        return {
                            testIds: locationTestAndPanel?.testDetails?.map((test: any) => test?.id),
                            panelIds: locationTestAndPanel?.panelDetails?.map((panel: any) => panel?.id)
                        }
                    });
                }
            })
            .catch((err: any) => {
            })
    }, []);

    useEffect(() => {
        handleGetLocationTestAndPanel(locationId);
    }, [locationId, handleGetLocationTestAndPanel]);

    useEffect(() => {
        if (selectedTestsAndPanels?.testIds?.length > 0 || selectedTestsAndPanels?.panelIds?.length > 0) {
            setIsEdited(true);
            setSelectedTestAndTestPanelIds(selectedTestsAndPanels);
        }
    }, [selectedTestsAndPanels]);

    const handleActiveTabChange = useCallback((tab: any) => {
        setActiveTab(tab);
    }, []);

    const handleViewDetailsDrawerOpen = useCallback((details: any) => {
        if (activeTab === TEST_PANELS) {
            const testNames = details?.testIds?.map((testId: any) => {
                const test = labTest?.find((test: any) => test?.id === testId);
                return test.name;
            });
            const testObject = {...details, tests: testNames};
            setTestOrPanelDetails(testObject);
        } else {
            const biomarkerNames = details?.biomarkerIds?.map((biomarkerId: any) => {
                const biomarker = biomarkerList?.find((biomarker: any) => biomarker?.id === biomarkerId);
                return biomarker?.name;
            });
            setTestOrPanelDetails({...details, biomarkers: biomarkerNames});
        }
        setViewDetailsDrawerOpen(true);
    }, [labTest, activeTab, biomarkerList]);

    const addLocationTestAndPanels = useCallback(() => {
        setIsSubmitting(true);
        commonService._location.addLocationTestAndPanels(locationId, {
            ...selectedTestAndTestPanelIds,
            lastCompletedStep: lastCompletedStep
        })
            .then((res: any) => {
                setIsSubmitting(false);
                next(selectedTestAndTestPanelIds);
            })
            .catch((err: any) => {
                setIsSubmitting(false);
            });
    }, [locationId, selectedTestAndTestPanelIds, next, lastCompletedStep]);

    return (
        <div className={'location-test-and-panels-add-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Tests and Panels'}
                tooltipData={"Tests and Panels"}
                handleClick={prev}
            />
            <div className="t-form attachments-with-title-wrapper">
                <div className={'no-form'}>
                    <div className="t-form-controls-wrapper">
                        <div className={'lab-test-and-panel-tabs-wrapper'}>
                            <TabsWrapperComponent>
                                <TabsComponent
                                    value={activeTab}
                                    allowScrollButtonsMobile={false}
                                    variant={"fullWidth"}
                                    onUpdate={(e: any, v: any) => {
                                        handleActiveTabChange(v)
                                    }}
                                >
                                    <TabComponent label={"TESTS"} value={"tests"}/>
                                    <TabComponent label={"Test panels"} value={'test_panels'}/>
                                </TabsComponent>
                                <TabContentComponent selectedTab={activeTab} value={TESTS}>
                                    {
                                        isLocationTestAndPanelLoading && <LoaderComponent/>
                                    }
                                    {
                                        isLocationTestAndPanelLoaded && <>
                                            {labTest?.filter((test: any) => test?.isActive && test?.testDetail?.isActive)?.length > 0 ?
                                                labTest?.filter((test: any) => test?.isActive && test?.testDetail?.isActive)?.map((activeTest: any, index: any) => {
                                                        return (
                                                            <div key={index} className={'lab-list-item'}>
                                                                <div className={'lab-list-item-name-and-selection'}>
                                                                    <CheckBoxComponent
                                                                        checked={selectedTestAndTestPanelIds?.testIds?.includes(activeTest?.testId)}
                                                                        disabled={!activeTest?.testDetail?.isActive}
                                                                        onUpdate={(isChecked: boolean) => {
                                                                            setIsEdited(true)
                                                                            if (isChecked) {
                                                                                setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                        return {
                                                                                            ...prevState,
                                                                                            testIds: [...prevState?.testIds, activeTest?.testId]
                                                                                        }
                                                                                    }
                                                                                )

                                                                            } else {
                                                                                // remove the test from the selected list
                                                                                setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        testIds: prevState?.testIds?.filter((id: any) => id?.id !== activeTest?.testId)
                                                                                    }
                                                                                });
                                                                            }
                                                                        }}
                                                                        name={commonService.capitalizeFirstLetterOfEachWord(activeTest?.testDetail?.name)}
                                                                    />
                                                                    <div className={'lab-list-item-name'}>
                                                                        {commonService.capitalizeFirstLetterOfEachWord(activeTest?.testDetail?.name)}
                                                                    </div>
                                                                </div>
                                                                <div className={'lab-list-item__action'}>
                                                                    <div className={'underline-button'} onClick={() => {
                                                                        handleViewDetailsDrawerOpen(activeTest?.testDetail);
                                                                    }}>
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                ) :
                                                <StatusCardComponent title={"No tests found"}/>
                                            }
                                        </>
                                    }
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_PANELS}>
                                    {
                                        isLocationTestAndPanelLoading && <LoaderComponent/>
                                    }
                                    {
                                        isLocationTestAndPanelLoaded && <>
                                            {labPanel?.filter((panel: any) => panel?.isActive && panel?.panelDetail?.isActive)?.length > 0 ?
                                                labPanel?.filter((panel: any) => panel?.isActive && panel?.panelDetail?.isActive)?.map((testPanel: any, index: number) => {
                                                        return (
                                                            <div key={index} className={'lab-list-item'}>
                                                                <div className={'lab-list-item-name-and-selection'}>
                                                                    <CheckBoxComponent
                                                                        checked={selectedTestAndTestPanelIds?.panelIds?.includes(testPanel?.panelId)}
                                                                        disabled={!testPanel?.panelDetail?.isActive}
                                                                        onUpdate={(isChecked: boolean) => {
                                                                            setIsEdited(true)
                                                                            if (isChecked) {
                                                                                setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        panelIds: [...prevState?.panelIds, testPanel?.panelId]
                                                                                    }
                                                                                });
                                                                            } else {
                                                                                //remove the panel from the selected list
                                                                                setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                                    return {
                                                                                        ...prevState,
                                                                                        panelIds: prevState?.panelIds?.filter((id: any) => id?.id !== testPanel?.panelId)
                                                                                    }
                                                                                });
                                                                            }
                                                                        }}
                                                                        name={commonService.capitalizeFirstLetterOfEachWord(testPanel?.panelDetail?.name)}
                                                                    />
                                                                    <div className={'lab-list-item-name'}>
                                                                        {commonService.capitalizeFirstLetterOfEachWord(testPanel?.panelDetail?.name)}
                                                                    </div>
                                                                </div>
                                                                <div className={'lab-list-item__action'}>
                                                                    <div className={'underline-button'} onClick={() => {
                                                                        handleViewDetailsDrawerOpen(testPanel?.panelDetail);
                                                                    }}>
                                                                        View Details
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                ) :
                                                <StatusCardComponent title={"No test panels found"}/>
                                            }
                                        </>
                                    }
                                </TabContentComponent>
                            </TabsWrapperComponent>
                        </div>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            fullWidth={true}
                            handleClick={cancel}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth={true}
                            isLoading={isSubmitting}
                            handleClick={isEdited ? addLocationTestAndPanels : next}
                        >
                            {isEdited ? "Next" : "Skip"}
                        </ButtonComponent>
                    </div>
                </div>
            </div>
            <DrawerComponent
                title={''}
                open={viewDetailsDrawerOpen}
                onClose={() => {
                    setViewDetailsDrawerOpen(false)
                }}
            >
                <TestDetailsComponent TESTS={TESTS} testOrPanelDetails={testOrPanelDetails} TEST_PANELS={TEST_PANELS}
                                      activeTab={activeTab}/>
            </DrawerComponent>
        </div>
    );

};

export default LocationTestAndPanelsAddComponent;
